import React, { useState } from 'react';
import { History, ChevronDown } from 'lucide-react';
import { formatSubmitted } from '@/components/responseDetail/DetailHeader';
import { OriginBadge } from '@/components/responseDetail/FactorTagRow';

// Audit trail: tags removed by people stay on record (never silently deleted).
export default function TagHistory({ removed }) {
  const [open, setOpen] = useState(false);
  if (!removed?.length) return null;
  return (
    <div className="mt-4 pt-3 border-t border-dashed border-[#E2E8F0]" data-testid="factor-tag-history">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between text-xs font-semibold text-[#64748B] hover:text-[#1A3E6F] transition-colors" data-testid="factor-tag-history-toggle">
        <span className="inline-flex items-center gap-1.5"><History className="w-3.5 h-3.5" /> Tag history · {removed.length} removed</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <ul className="mt-3 space-y-2.5">
          {removed.map((t) => (
            <li key={t.factor_id} className="text-xs text-[#475569] bg-[#F8FAFC] rounded-lg px-3 py-2" data-testid={`factor-tag-removed-${t.factor_id}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="line-through decoration-[#CBD5E1] text-[#334155] font-medium">{t.attribute_name} · {t.factor_name}</span>
                <OriginBadge method={t.method} />
              </div>
              <p className="mt-1 text-[11px] text-[#94A3B8]">Removed by {t.removed_by_name || 'a team member'} · {formatSubmitted(t.removed_at)}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
